.assessmentSchedule {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.assessmentCalloutContainer {
    width: 25%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.assessmentCallout {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: center;
}

.assessmentCallout:hover{
    cursor: pointer;
}

.assessmentNumber, .assessmentNumberOverdue {
    text-align: center;
    letter-spacing: 0.1px;
    color: var(--hps-white);
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.assessmentNumberOverdue {
    color: var(--hps-yellow);
}

.controlsAssessed{
    width: 75%;
}
